import React, { useLayoutEffect, useMemo } from 'react';
import { Link } from 'react-router-dom';
import {
  APP_STORE_BUYDROP_URL,
  PLAY_STORE_BUYDROP_URL,
  buyerAppStoreAnchorProps,
  buyerPlayStoreAnchorProps,
} from '../constants/appLinks';

function mobileStoreUrl(): string | null {
  if (typeof navigator === 'undefined') return null;
  const ua = navigator.userAgent || '';
  if (/Android/i.test(ua)) return PLAY_STORE_BUYDROP_URL;
  const isIOS =
    /iPad|iPhone|iPod/i.test(ua) ||
    (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
  if (isIOS) return APP_STORE_BUYDROP_URL;
  return null;
}

const DownloadApp: React.FC = () => {
  const storeUrl = useMemo(() => mobileStoreUrl(), []);

  useLayoutEffect(() => {
    if (storeUrl) window.location.replace(storeUrl);
  }, [storeUrl]);

  if (storeUrl) {
    return (
      <div className="min-h-screen flex items-center justify-center px-4">
        <p className="text-sm text-gray-500">Opening store…</p>
      </div>
    );
  }

  return (
    <div className="min-h-[60vh] flex flex-col items-center justify-center px-4 py-16">
      <h1 className="text-2xl font-bold text-gray-900 mb-2">Get BuyDrop</h1>
      <p className="text-gray-600 text-center max-w-sm mb-8">
        Download the buyer app for iOS or Android.
      </p>
      <div className="flex flex-col sm:flex-row gap-3">
        <a
          {...buyerAppStoreAnchorProps()}
          className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-xl bg-gray-900 text-white font-semibold hover:bg-gray-800 transition"
        >
          <i className="ri-apple-fill text-xl" aria-hidden />
          App Store
        </a>
        <a
          {...buyerPlayStoreAnchorProps()}
          className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-xl bg-white text-gray-900 font-semibold ring-1 ring-gray-300 hover:bg-gray-50 transition"
        >
          <i className="ri-google-play-fill text-xl text-green-600" aria-hidden />
          Google Play
        </a>
      </div>
      <Link to="/" className="mt-8 text-sm text-gray-500 hover:text-gray-700">
        Back to BuyDrop
      </Link>
    </div>
  );
};

export default DownloadApp;
